import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Box, CircularProgress, IconButton } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { AvatarVideoData } from "../../../../Types/VideoSuite-Types";
import { SearchInput } from "../../../../shared/SearchInput";
import { useMemo, useState } from "react";
import { SelectOptionBreadcrumbs } from "./SelectOptionBreadcrumbs";
import { AvatarsGender } from "./VideoSuiteHelper";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  bgcolor: "var(--sub_background6)",
  boxShadow: 24,
  outline: "none",
  borderRadius: "12px",
};

interface SelectAvatarModalProps {
  open: boolean;
  handleClose: () => void;
  avatars: AvatarVideoData[];
  handleSelectAvatar: (avatar: AvatarVideoData) => void;
  selectedAvatar: AvatarVideoData | undefined;
  isLoading: boolean;
  displayGender: boolean;
}

export const SelectAvatarModal = ({
  open,
  handleClose,
  avatars,
  handleSelectAvatar,
  isLoading,
  displayGender,
  selectedAvatar,
}: SelectAvatarModalProps) => {
  const [searchInputValue, setSearchInputValue] = useState("");
  const [selectedGender, setSelectedGender] = useState<string>(
    selectedAvatar?.gender || AvatarsGender[0]
  );
  const handleSetActiveAvatar = (avatar: AvatarVideoData) => {
    handleSelectAvatar(avatar);
    handleCloseModal();
  };

  const filteredAvatars = useMemo(() => {
    if (!searchInputValue) {
      return avatars.filter(
        (avatar) => avatar.gender.toLowerCase() === selectedGender.toLowerCase()
      );
    } else {
      return avatars.filter(
        (avatar) =>
          avatar.gender.toLowerCase() === selectedGender.toLowerCase() &&
          avatar.avatar_name
            .toLowerCase()
            .includes(searchInputValue.toLowerCase())
      );
    }
  }, [selectedGender, avatars, searchInputValue]);

  const handleCloseModal = () => {
    setSearchInputValue("");
    handleClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          ...style,
          "@media (max-width: 900px)": {
            width: "98%",
          },
        }}
      >
        <Box className="avatar-modal-header">
          <Typography>Choose a style</Typography>
          <IconButton
            aria-label="close"
            color="inherit"
            sx={{}}
            onClick={handleCloseModal}
          >
            <ClearIcon />
          </IconButton>
        </Box>
        <Box className="avatar-modal-body">
          {displayGender && (
            <Box className="avatar-modal-body-header">
              <Box>
                <SelectOptionBreadcrumbs
                  options={AvatarsGender}
                  selectedOption={selectedGender}
                  handleSelectOption={setSelectedGender}
                />
              </Box>
              <Box className="search-box-container">
                <SearchInput
                  searchInputValue={searchInputValue}
                  setSearchInputValue={setSearchInputValue}
                  placeholder="Search Avatars"
                />
              </Box>
            </Box>
          )}
          <Box className="avatars-container">
            {isLoading && searchInputValue ? (
              <Box className="empty-message">
                <CircularProgress sx={{ color: "#12b6ea" }} />
              </Box>
            ) : filteredAvatars.length > 0 ? (
              filteredAvatars?.map((avatar, i) => (
                <Box
                  key={i}
                  className="avatar-style"
                  sx={{ cursor: "pointer" }}
                  onClick={() => handleSetActiveAvatar(avatar)}
                >
                  <Box className="image-box">
                    <Box className="avatar-style-image">
                      <img
                        src={avatar.preview_image_url}
                        alt=""
                        style={{ width: "100%", height: "100%" }}
                      />
                    </Box>
                  </Box>
                  <Typography>{avatar.avatar_name}</Typography>
                </Box>
              ))
            ) : (
              <Box className="empty-message">No avatars found</Box>
            )}
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};
